/**
 * MessageTimeline.jsx — vertical timeline for message lifecycle events.
 *
 * Props:
 *   events: [{ type: 'queued'|'sent'|'delivered'|'read'|'failed', at: ISO, meta?: {} }]
 */

import React from 'react';
import { Timeline, Tag } from 'antd';
import {
  ClockCircleOutlined,
  SendOutlined,
  CheckOutlined,
  CheckCircleFilled,
  EyeOutlined,
  CloseCircleFilled,
} from '@ant-design/icons';

const STYLE = {
  queued:    { color: 'gray',   icon: <ClockCircleOutlined />,  label: 'Queued' },
  sent:      { color: 'blue',   icon: <SendOutlined />,         label: 'Sent' },
  delivered: { color: 'green',  icon: <CheckCircleFilled />,    label: 'Delivered' },
  read:      { color: 'cyan',   icon: <EyeOutlined />,          label: 'Read' },
  failed:    { color: 'red',    icon: <CloseCircleFilled />,    label: 'Failed' },
  accepted:  { color: 'blue',   icon: <CheckOutlined />,        label: 'Accepted' },
};

const fmt = (iso) => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString('en-IN', {
      day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit',
    });
  } catch (_) { return String(iso); }
};

export default function MessageTimeline({ events = [] }) {
  if (!events || events.length === 0) {
    return <div style={{ color: '#8c8c8c', fontSize: 13 }}>No events yet.</div>;
  }

  return (
    <Timeline
      items={events.map((ev) => {
        const s = STYLE[ev.type] || { color: 'gray', icon: null, label: ev.type };
        return {
          color: s.color,
          dot: s.icon,
          children: (
            <div>
              <strong>{s.label}</strong>
              <span style={{ color: '#8c8c8c', marginLeft: 8, fontSize: 12 }}>{fmt(ev.at)}</span>
              {ev.meta?.error_code && (
                <Tag color="red" style={{ marginLeft: 8 }}>{ev.meta.error_code}</Tag>
              )}
              {ev.meta?.error_message && (
                <div style={{ fontSize: 12, color: '#8c4a4a', marginTop: 2 }}>
                  {ev.meta.error_message}
                </div>
              )}
            </div>
          ),
        };
      })}
    />
  );
}
